import React from "react";
import Icon from "../icons/Icon";
import iconsList from "../icons/iconsList";
import classes from "./InfoBar.module.css";

const InfoBar = ({ text, icon }) => {
    return (
        <div className={classes.InfoBar}>
            <Icon name={icon ?? iconsList.infoCircle} size="16px" className={classes.InfoIcon} />
            <p className={classes.InfoText}>{text}</p>
        </div>
    );
};

export default InfoBar;
